
import { Component, Vue } from 'vue-property-decorator'
import { MemberVO } from '@/views/biz/login/vo/MemberVO.vo'
import { CommonSearchIVO, CommonSearchOVO } from '@/views/biz/omr/vo/SearchVO.vo'
import { ReportHistoryOVO } from '@/views/biz/omr/vo/Omr.vo'
import Constants from '@/constants'
import axios from 'axios'

@Component
export default class OmrMain extends Vue {
  member: MemberVO = {} as MemberVO;
  exams: Array<CommonSearchOVO> = [];
  examInfo: CommonSearchOVO = {} as CommonSearchOVO;
  reportHistoryList = [] as Array<ReportHistoryOVO>;
  isUsetestPaperLibrary = false;

  // 즐겨찾기 등록 및 해제
  toggleFavorSubject(): void {
    axios.post('omr/favor', this.examInfo)
    .then(r => {
      r.data.register ? this.$toast('즐겨찾기로 등록했어요.'): this.$toast('즐겨찾기가 해제되었어요.');
      this.examInfo.fsNo = r.data.fsNo;
    })
  }

  selectedSubject(item: CommonSearchOVO): void {
    this.$router.push({name: 'OmrLearn', params: {emNo: item.emNo}})
  }

  // 다시 풀기
  retry(item: ReportHistoryOVO): void {
    this.$router.push({name: 'OmrLearn', params: {emNo: item.emNo}})
  }

  // 오답노트 전체 목록으로 이동
  movewrongAnswerNote() {
    if(!this.reportHistoryList.length) {
      this.$toast('제출 이력이 없어요');
      return;
    }

    this.$router.push({name: 'WrongAnswerNotes', params: {emExam: this.examInfo.emExam, smNo: this.examInfo.smNo}})
  }

  created(): void {
    axios.get('/member')
    .then(r => {
      if(r.data) {
        this.member = r.data;

        // 선택한 시험정보 조회
        axios.get('/omr/exams')
        .then(r => {
          this.exams = r.data;
    
          if(this.exams.length) {
            this.examInfo = this.exams[0]
    
            const param: CommonSearchIVO = {} as CommonSearchIVO;
            param.emExam = this.examInfo.emExam;
            param.smNo = this.examInfo.smNo;
            param.limit = 1;
    
            // 최근 채점 이력
            axios.get(`omr/report-history`, {params: param})
            .then(r=>{
              this.reportHistoryList = r.data;
            })
          }
        })
      }
    })

    this.isUsetestPaperLibrary = Constants.IS_USED_TEST_PAPER_LIBRARY;
  }
  
}
